var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgWhyChoose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282,
    height: 216,
    viewBox: "0 0 282 216",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.873 0.953125C13.4091 0.953125 0.873047 13.4892 0.873047 28.9531V187.367C0.873047 202.831 13.4091 215.367 28.873 215.367H253.877C269.341 215.367 281.877 202.831 281.877 187.367V84.7646C281.877 73.719 272.922 64.7646 261.877 64.7646H237.836C226.791 64.7646 217.836 55.8103 217.836 44.7646V20.9531C217.836 9.90743 208.882 0.953125 197.836 0.953125H28.873Z",
    fill: "#F6F6FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWhyChoose);
export default __webpack_public_path__ + "static/media/bg-why-choose.43ab77b0409f2f420b3fa8f8ec7c5332.svg";
export { ForwardRef as ReactComponent };